import styled from 'styled-components'

export const ViewContainer = styled.div`

    ::-webkit-scrollbar {
            width: 6px;
            height : 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--gray-600);
            border-radius: 10px;
            width: 6px;
            height: 6px;
        }
    ::-webkit-scrollbar-corner {
        background: transparent;
    }
    

    .customScroll{
        margin-right: 8px;
        ::-webkit-scrollbar {
            width: 6px;
            height : 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--gray-600);
            border-radius: 10px;
            width: 6px;
            height: 6px;
        }
    ::-webkit-scrollbar-corner {
        background: transparent;
    }
    }



    position: relative;
    width: 100%;
    height: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    background-color: ${({ theme }) => theme['gray-0']};
    overflow: auto;

    .titleBar {
        width: 100%;
        height: 40px;
        background: ${({ theme }) => theme['gray-100']};
        font-weight: 700;
        font-size: 15px;
        padding: 0 16px;
        display: flex;
        align-items: center;
    }
    .pagination {
        width: 100%;
        height: 64px;
        display: flex;
        flex-direction: row;
        align-items: center;
        /* justify-content: space-between; */
        padding: 0 16px;
        justify-content: end;
        gap: 25px;

        .export-button {
            padding: 6px;
            height: 36px;
            width: 130px;
            /* margin-left: 10px; */
            background: var(--gray-0);
            border-radius: 3px;
        }
    }

    .tableContainer {
        width: 100%;
        height: calc(100% - 104px);
        padding: 0 16px;
        overflow: auto;

        thead th {
            position: sticky;
            top: 0;
            z-index: 1;
        }
    }

    .tableContainerWithGraphic {
        width: 100%;
        height: calc(100% - 392px);
        padding: 0 16px;
        overflow: auto;

        



        thead th {
            position: sticky;
            top: 0;
            z-index: 1;
        }
    }

    table {
        width: 100%;
        height: 100%;

        th {
            background: ${({ theme }) => theme['gray-200']};
            text-transform: uppercase;
            font-size: 11px;
            &,
            * {
                transition: none;
            }
        }

        th button {
            padding: 2px 16px 0px;
            height: 32px;
            text-transform: uppercase;
            font-size: 11px;
            border: none;
            font-weight: 600;
            color: ${({ theme }) => theme['gray-900']};
        }
        th button:hover {
            background-color: ${({ theme }) => theme['gray-700']};
            color: ${({ theme }) => theme['gray-0']};
        }
        th button:focus {
            background-color: ${({ theme }) => theme['gray-700']};
            color: ${({ theme }) => theme['gray-0']};
        }
        th button:active {
            background-color: ${({ theme }) => theme['gray-700']};
            color: ${({ theme }) => theme['gray-0']};
        }

        th button i {
            font-size: 10px;
            width: 12px;
            margin-left: 4px;
            height: 16px;
        }

        tr {
            width: 100%;
            display: table;
            word-break: break-all;
        }

        td {
            padding: 8px 16px;
            border-bottom: 1px solid;
            border-color: ${({ theme }) => theme['gray-200']};
            font-size: 12px;
            color: ${({ theme }) => theme['gray-800']};
        }

        .trWithGraph {
            td {
                padding: 0;
                .toGraph {
                    width: 100%;
                    height: 100%;
                    padding: 8px 16px;
                    text-align: left;
                    background: transparent;
                    border: none;
                }
            }
        }

        .trWithGraph:hover {
            background: ${({ theme }) => theme['blue-200']};
        }

        
     

        .UNKNOWN {
            color: ${({ theme }) => theme['gray-700']};
        }

        .Tolerable {
            color: ${({ theme }) => theme['yellow-700']};
        }

        .Unacceptable {
            color: ${({ theme }) => theme['red-700']};
        }

        .Intolerable {
            color: ${({ theme }) => theme['red-700']};
        }

        .Acceptable {
            color: ${({ theme }) => theme['green-700']};
        }

        .Tolerável {
            color: ${({ theme }) => theme['yellow-700']};
        }

        .Inaceitável {
            color: ${({ theme }) => theme['red-700']};
        }

        .Intolerável {
            color: ${({ theme }) => theme['red-700']};
        }

        .Aceitável {
            color: ${({ theme }) => theme['green-700']};
        }

        .barrierStatus {
            text-transform: capitalize;
            color: #606A80;            

            &.ACTIVE {
            color: #129a96;
            }

            &.INACTIVE {
            color: ${({ theme }) => theme['red-700']};
            }

        }

        .type {
            text-transform: capitalize;
        }

        .trSelected {
            background: ${({ theme }) => theme['gray-100']};
            td {
                padding: 0;
                .toGraph {
                    /* background: ${({ theme }) => theme['gray-100']}; */
                }
            }
        }
    }

    .tableHeader {
        height: 36px;
        color: var(--gray-700);
        font-family: var(--font-bold);
        font-size: 12px;
        white-space: nowrap;
        position: sticky;
        top: 0;
        padding-top: 15px;
    }

    .ScrollbarsCustom {
        .ScrollbarsCustom-Wrapper {
            width: 100%;
            height: calc(100% - 50px);
        }

        .ScrollbarsCustom-TrackY {
            height: calc(100% - 60px) !important;
        }
    }

    .clearAllFilters {
        position: absolute;
        left: 15px;
        top: 60px;
        background: transparent;
        border: none;
        font-weight: 600;

        i {
            margin-left: 4px;
        }
    }

    .risk-acceptance-header {
        .common-width {
            width: 20%;
        }
    }
    .risk-acceptance {
        .common-width {
            width: 20%;
        }
        /* &.first-margin {
            margin-top: 36px;
        } */
    }

    .resource-threat-status-header {
        .common-width {
            width: 16.6%;
        }
        .diff-size {
            /* if has a diff size */
        }
    }
    .resource-threat-status {
        .common-width {
            width: 16.6%;
        }
        .diff-size {
            /* if has a diff size */
        }
        &.first-margin {
            /* margin-top: 36px; */
        }
    }

    .resource-consequence-status-header {
        .common-width {
            width: 16.6%;
        }
    }
    .resource-consequence-status {
        .common-width {
            width: 16.6%;
        }
        &.first-margin {
            /* margin-top: 36px; */
        }
    }

    .resource-barrier-status-header {
        .common-width {
            width: 11.1%;
        }
    }
    .resource-barrier-status {
        .common-width {
            width: 11.1%;
        }
        &.first-margin {
            /* margin-top: 36px; */
        }
    }

    .resource-barrier-pfd-header {
        .common-width {
            width: 11.1%;
        }
    }
    .resource-barrier-pfd {
        .common-width {
            width: 11.1%;
        }
        &.first-margin {
            /* margin-top: 36px; */
        }
    }

    .resource-barrier-analysis-header {
        .common-width {
            width: 10%;
        }
    }
    .resource-barrier-analysis {
        .common-width {
            width: 10%;
        }
        /* &.first-margin {
            margin-top: 36px;
        } */
    }

    .manual-interaction-barrier-status-header {
        .common-width {
            width: 10%;
        }
    }
    .manual-interaction-barrier-status {
        .common-width {
            width: 10%;
        }
        &.first-margin {
            /* margin-top: 36px; */
        }
    }

    .mandatory-barriers-header {
        .common-width {
            width: 16.6%;
        }
    }
    .mandatory-barriers {
        .common-width {
            width: 16.6%;
        }
    }
`

export const NoInfo = styled.div`
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 20px;
`
export const NoData = styled.div`
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 20px;
    margin-top: 70px;
`
